import { formatMMDDYY } from '../../../../utils/dates';
import { RECYCLING_PRODUCT_TYPES } from '../../../../utils/tbbRegistration';
import TakeBagBackIcon from '../../../../global/SvgComponents/Tbb_svg';
import Recycle from '../../../../global/SvgComponents/Recycle_svg';

import './MembershipOrdersListRow.scss';

const ORDER_PRODUCTS = [
  {
    id: RECYCLING_PRODUCT_TYPES.TEXTIL,
    icon: TakeBagBackIcon,
    label: 'Take Back Bag',
  },
  {
    id: RECYCLING_PRODUCT_TYPES.TECH,
    icon: Recycle,
    label: 'Tech Take Back Box',
  },
];

const MembershipOrdersListRow = ({
  rowData,
}) => {
  const {
    createdAt,
    ...rest
  } = rowData;
  const orderProducts = rest;

  return (
    <div className="MembershipOrdersListRow">
      <span className="MembershipOrdersListRow__date">
        {formatMMDDYY(createdAt)}
      </span>
      {ORDER_PRODUCTS.map(({ id, icon: Icon, label }) => (
        <div
          key={`membership-orders-row-item-${id}`}
          className="MembershipOrdersListRow__item"
        >
          <Icon
            color="var(--trashie-ui-faded-black-60)"
            width={16}
            height={16}
          />
          <div className="MembershipOrdersListRow__item-label">
            {label}
          </div>
          <div className="MembershipOrdersListRow__item-status">
            <div className="MembershipOrdersListRow__item-status-label">
              <span>Ordered:</span>
              <span>{orderProducts[id]?.ordered ?? 0}</span>
            </div>
            <div className="MembershipOrdersListRow__item-status-label">
              <span>Returned:</span>
              <span>{orderProducts[id]?.shipped ?? 0}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MembershipOrdersListRow;
